import axios from "axios";
import { time } from "console";
import { ShowAwaiting, HideAwaiting } from "../../../util/Awaiting";
import { authenticatedHeader } from "../../DefaultConfig";
import { StatisticsURL } from "../../Services";
import { getFromStorage, saveToStorage } from "../../../util/StorageUtil";

export async function getHomepageData(hour: number) {
  
  if (getFromStorage("homePageData" + hour) == null) {
    ShowAwaiting();
    var res = await axios.post(
      StatisticsURL + "api/statistics/overall/home",
      {
        hour: hour,
      },
      authenticatedHeader()
    );
    saveToStorage("homePageData" + hour, res.data, 100000);
    HideAwaiting();
    return res.data;
  }
  return getFromStorage("homePageData" + hour);
  
}
